import { useEffect } from "react";
import { useGlobalMouseEventContext } from "../context/MouseEventContext";
import {
  useKeyEventApiContext,
  KeyEventSubscriber,
} from "../context/KeyEventContext";

export const useKeyPressEvent = (
  subscriber: KeyEventSubscriber,
  isInterested: boolean
) => {
  const { addKeyPressSubscriber, removeKeyPressSubscriber } =
    useKeyEventApiContext();

  useEffect(() => {
    if (isInterested) {
      //if (subscriber.id === "fuzzy-search") {
      //console.log("adding fuzzy search subscriber");
      //}
      //if (subscriber.id === "word___126600") {
      //console.log("adding subscriber", subscriber.id);
      //}
      addKeyPressSubscriber(subscriber);
    } else {
      removeKeyPressSubscriber(subscriber);
      if (subscriber.id === "word___126600") {
        console.log("removing subscriber", subscriber.id);
      }
    }
    return () => removeKeyPressSubscriber(subscriber);
  }, [
    isInterested,
    subscriber.id,
    subscriber.priority,
    subscriber.useCallbackGeneratedCB,
  ]);
};

export const useMouseEventLock = (): {
  pause: () => void;
  resume: () => void;
  arePaused: boolean;
} => {
  const { mouseEventsArePaused, setMouseEventsArePaused } =
    useGlobalMouseEventContext();
  return {
    pause: () => setMouseEventsArePaused(true),
    resume: () => setMouseEventsArePaused(false),
    arePaused: mouseEventsArePaused,
  };
};
